import { render, staticRenderFns } from "./Landing2Partners.vue?vue&type=template&id=5ab71734&scoped=true"
import script from "./Landing2Partners.vue?vue&type=script&lang=js"
export * from "./Landing2Partners.vue?vue&type=script&lang=js"
import style0 from "./Landing2Partners.vue?vue&type=style&index=0&id=5ab71734&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab71734",
  null
  
)

export default component.exports